module.exports = __webpack_public_path__ + "static/media/grocery-product-2.1d6780c1.png";